import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Grid, Typography, Button, withStyles } from 'material-ui';
import { CircularProgress } from 'material-ui/Progress';
import { withApollo } from 'react-apollo';
import { withAlertHandler } from 'entoro-shared';
import { getBrokerageDocusignEnvelopeMutation } from '../../../../../apollo';

const styles = () => ({
  container: {
    margin: '0 auto',
  },
  title: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
    marginBottom: '10px',
  },
});

class BrokerageAgreement extends Component {
  state = {
    loading: false,
  };

  openDocusignEnvelope = async () => {
    const { handleSnackbarError, initialValues, offer, client } = this.props;
    try {
      this.setState({ loading: true });
      const {
        data: {
          getBrokerageDocusignEnvelope: { url },
        },
      } = await client.mutate({
        mutation: getBrokerageDocusignEnvelopeMutation,
        variables: {
          input: {
            offerId: offer._id,
            investmentId: initialValues._id,
            returnUrl: `${window.location.origin}/offer/${offer._id}?investmentId=${initialValues._id}&type=brokerage`,
          },
        },
      });
      window.location.replace(url);
    } catch (error) {
      this.setState({ loading: false });
      handleSnackbarError(error);
    }
  };

  render() {
    const { classes } = this.props;
    const { loading } = this.state;

    const SignButton = ({ input: { value }, meta: { touched, error } }) => {
      const buttonText =
        value === 'SIGNED' ? 'VIEW DOCUMENTS' : 'GO TO DOCUSIGN';

      return (
        <Fragment>
          <Typography align='center' className={classes.title}>
            <span style={touched && error ? { color: '#ff1744' } : null}>
              {value === 'SIGNED' ? 'You have signed all documents.' : error}
            </span>
          </Typography>
          {value !== 'SIGNED' && (
            <Typography align='center' className={classes.subheading}>
              You will be returned to this screen after you sign the documents
            </Typography>
          )}
          <Typography align='center'>
            <Button
              disabled={loading}
              className='action-button'
              onClick={this.openDocusignEnvelope}
              disableRipple
            >
              {loading ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CircularProgress size={20} color='inherit' />
                  &nbsp;
                  {buttonText}
                </div>
              ) : (
                buttonText
              )}
            </Button>
          </Typography>
        </Fragment>
      );
    };

    SignButton.propTypes = {
      input: PropTypes.object.isRequired,
      meta: PropTypes.object.isRequired,
    };

    return (
      <div className='step'>
        <Grid
          container
          spacing={16}
          justify='center'
          className={classes.container}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Field name='brokerageAgreementStatus' component={SignButton} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

BrokerageAgreement.propTypes = {
  classes: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
};

export default withStyles(styles)(
  withApollo(withAlertHandler(BrokerageAgreement))
);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/BrokerageAgreement.js